import React from 'react'
import UpgradeToGetStarted from '../../components/UpgradeToGetStarted/UpgradeToGetStarted'

const FinancialsExpenses = () => {
    return (
        <div>
            <UpgradeToGetStarted
                imageSrc="/assets/images/blank-page/financials-expenses.png"
                imageAlt="financials expenses"
                heading="Expenses"
                description="Track and manage your spending with ease — upload receipts, categorize expenses, link them to projects or client budgets, and integrate them seamlessly into your invoices."
                lockIconSrc="./assets/images/app-activity/insights/lock-icon.svg"
                promoText="Schedule a call with our sales team to discover more about Invoices."
                buttonText="Upgrade to get started"
                showTextContent={true}
            />

        </div>
    )
}

export default FinancialsExpenses
